import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { noop } from '../../../../utils/noop.js';
import { i18n } from '../../../../i18n/translate.js';
import { ActionButton } from '../ActionButton/component.js';
var _excluded = ["action", "actionType", "keyField", "row", "selectMember"];

var EditActionButton = function EditActionButton(_ref) {
  var _ref$action = _ref.action,
      action = _ref$action === void 0 ? noop : _ref$action,
      _ref$actionType = _ref.actionType,
      actionType = _ref$actionType === void 0 ? 'select' : _ref$actionType,
      _ref$keyField = _ref.keyField,
      keyField = _ref$keyField === void 0 ? 'id' : _ref$keyField,
      row = _ref.row,
      selectMember = _ref.selectMember,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getActionProps = function getActionProps() {
    switch (actionType) {
      case 'route':
        return {
          action: "/".concat(row[keyField]),
          actionType: 'link'
        };

      case 'select':
        return {
          action: selectMember ? function () {
            return selectMember(row[keyField]);
          } : action,
          actionType: 'callToAction'
        };

      default:
        return {
          action: action,
          actionType: actionType
        };
    }
  };

  return /*#__PURE__*/React.createElement(ActionButton, _extends({
    row: row,
    title: i18n.t('Edit'),
    tooltip: i18n.t('Edit') // @ts-ignore
    ,
    icon: "pen"
  }, rest, getActionProps()));
};

EditActionButton.displayName = "EditActionButton";
export { EditActionButton };